import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Skeleton } from '.';
import { WrapperVertical } from '../../gatsby-theme-docz/components/Wrapper';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "skeleton"
    }}>{`Skeleton`}</h1>
    <p>{`Element to use while the main component in loading`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<Skeleton height={50} width={100} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Skeleton,
      WrapperVertical,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Skeleton height={50} width={100} mdxType="Skeleton" />
    </Playground>
    <h2 {...{
      "id": "sizes"
    }}>{`Sizes`}</h2>
    <Playground __position={1} __code={'<WrapperVertical>\n  <Skeleton size=\"small\" width={200} />\n  <Skeleton size=\"medium\" width={200} />\n  <Skeleton size=\"large\" width={200} />\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Skeleton,
      WrapperVertical,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <Skeleton size="small" width={200} mdxType="Skeleton" />
        <Skeleton size="medium" width={200} mdxType="Skeleton" />
        <Skeleton size="large" width={200} mdxType="Skeleton" />
    </WrapperVertical>
    </Playground>
    <h2 {...{
      "id": "known-bugs"
    }}>{`Known bugs`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`shape`}</inlineCode>{`, `}<inlineCode parentName="li">{`size`}</inlineCode>{` and `}<inlineCode parentName="li">{`bgColor`}</inlineCode>{` does not work`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      